/**
 * Stadium-evening light rig — designed for cinematic, not "studio
 * lightbox" feel. Four-light setup plus a hemisphere for sky/ground
 * bounce:
 *
 *  - hemisphere: sky tint above, turf tint below — gives natural fill
 *    that follows surface orientation (sky-blue on shoulders, green
 *    on undersides) rather than a uniform ambient wash.
 *  - ambient (low): tiny non-directional floor so true shadow cores
 *    aren't ink-black, but kept well below the directional rig so the
 *    scene retains contrast.
 *  - key (warm): main directional from camera-right, casts shadows.
 *    Intensity bumped vs. the prior "polite" rig — stadium floodlights
 *    are bright. Shadow map at 2048² for crisp edges that still soften
 *    via the Canvas PCFSoftShadowMap setting.
 *  - fill (cool): low directional from the opposite side, models the
 *    cool half of the bowl reflecting back.
 *  - rim (warm amber): from behind + low, picks out player silhouettes
 *    against the dark stand wall.
 */
import { Color } from 'three';

export function Lighting() {
  return (
    <>
      <hemisphereLight intensity={0.45} color="#9ec5e8" groundColor="#1e3a22" />
      <ambientLight intensity={0.18} color="#ffffff" />
      {/* Warm key — main shadow-caster. Cinematic 1.6 intensity. */}
      <directionalLight
        position={[35, 55, 25]}
        intensity={1.6}
        color="#fff0c8"
        castShadow
        shadow-mapSize-width={2048}
        shadow-mapSize-height={2048}
        shadow-camera-near={1}
        shadow-camera-far={200}
        shadow-camera-left={-80}
        shadow-camera-right={80}
        shadow-camera-top={80}
        shadow-camera-bottom={-80}
        shadow-bias={-0.0005}
      />
      {/* Cool sky fill */}
      <directionalLight position={[-30, 35, -15]} intensity={0.5} color={new Color('#a8c8ff')} />
      {/* Warm rim from behind */}
      <directionalLight position={[10, 12, -50]} intensity={0.45} color="#ffb070" />
    </>
  );
}
